import { tss } from 'tss-react/mui';

const useDeviceVulnerabilityStyles = tss.create(({ theme }) => ({
  fetchTimeLabel: {
    display: 'flex',
    width: '100%'
  },

  fetchTimeSwitch: {
    marginLeft: 'auto',
    marginRight: 0,
    width: 28,
    height: 16,
    padding: 0,
    display: 'flex',
    '&:active': {
      '& .MuiSwitch-thumb': {
        width: 15
      },
      '& .MuiSwitch-switchBase.Mui-checked': {
        transform: 'translateX(9px)'
      }
    },
    '& .MuiSwitch-switchBase': {
      padding: 2,
      '&.Mui-checked': {
        transform: 'translateX(12px)',
        color: '#fff',
        '& + .MuiSwitch-track': {
          opacity: 1
        }
      }
    },
    '& .MuiSwitch-thumb': {
      boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
      width: 12,
      height: 12,
      borderRadius: 6,
      backgroundColor: '#fff',
      transition: theme.transitions.create(['width'], {
        duration: 200
      })
    },
    '& .MuiSwitch-track': {
      borderRadius: 16 / 2,
      opacity: 1,
      backgroundColor: 'var(--mui-palette-error-main)',
      boxSizing: 'border-box'
    },
    '& .MuiSwitch-switchBase.Mui-checked+.MuiSwitch-track': {
      backgroundColor: theme.vars.palette.primary.main
    }
  }
}));

export default useDeviceVulnerabilityStyles;
